import React, { useState } from 'react';
import { X, Database, Clock, Users, Activity, TrendingUp, AlertCircle, CheckCircle2, Calendar, Server, Zap, GitBranch,Network } from 'lucide-react';
import { StatusTag } from './StatusTag';
import { ConsumerTreeView } from './ConsumerTreeView';
import { ConsumerNetworkView } from './ConsumerNetworkView'; // Commented out - not used


export const DataContractDetailsModal = ({
  isOpen,
  onClose,
  contract
}) => {
  console.log("contract details", contract)
  const [viewMode, setViewMode] = useState('tree');

  if (!isOpen || !contract) return null;

  const getStatusDetails = () => {
    switch (contract.status) {
      case 'healthy':
        return {
          message: 'All systems are operating normally',
          recommendations: [
            'Continue monitoring data quality metrics',
            'Maintain current SLA compliance levels',
            'Regular health checks are passing'
          ]
        };
      case 'warning':
        return {
          message: 'Minor issues detected that may impact performance',
          recommendations: [
            'Review data quality metrics for anomalies',
            'Check consumer feedback for any issues',
            'Consider scaling resources if needed'
          ]
        };
      case 'critical':
        return {
          message: 'Critical issues require immediate attention',
          recommendations: [
            'Investigate data pipeline failures immediately',
            'Contact data engineering team',
            'Implement emergency data recovery procedures'
          ]
        };
    }
  };

  const statusDetails = getStatusDetails();

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div 
      className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4  z-[99999999]"
      onClick={handleBackdropClick}
    >
      <div className="bg-white z-999999 rounded-2xl shadow-2xl max-w-7xl w-[90vw] max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div className="flex items-center gap-4">
            <Database className="h-[30px] w-[30px] text-blue-600" />
            <div>
              <h2 className="text-2xl font-bold text-gray-900">{contract.name}</h2>
              <p className="text-gray-600 mt-1">{contract.description}</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <X className=" h-6 text-gray-500" />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 space-y-8">
          {/* Status Overview - COMMENTED OUT */}
          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-6">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-900">Current Status</h3>
              <StatusTag status={contract.status} size="lg" animate={contract.status === 'critical'} />
            </div>
            {/* <p className="text-gray-700">{statusDetails.message}</p> */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div className="bg-white rounded-lg p-4">
                <div className="flex items-center gap-2 mb-2">
                  <TrendingUp className=" h-5 text-blue-600" />
                  <span className="font-medium text-gray-900">SLA Compliance</span>
                </div>
                <div className="text-2xl font-bold text-gray-900">{contract.slaCompliance}%</div>
                <div className="w-full bg-gray-200 rounded-full h-2 mt-2">
                  <div 
                    className={`h-2 rounded-full transition-all duration-500 ${
                      contract.slaCompliance >= 95 ? 'bg-green-500' : 
                      contract.slaCompliance >= 80 ? 'bg-amber-500' : 'bg-red-500'
                    }`}
                    style={{ width: `${contract.slaCompliance}%` }}
                  ></div>
                </div>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="flex items-center gap-2 mb-2">
                  <CheckCircle2 className=" h-5 text-purple-600" />
                  <span className="font-medium text-gray-900">Data Quality</span>
                </div>
                <div className="text-2xl font-bold text-gray-900">{contract.dataQuality}%</div>
                <div className="w-full bg-gray-200 rounded-full h-2 mt-2">
                  <div 
                    className={`h-2 rounded-full transition-all duration-500 ${
                      contract.dataQuality >= 95 ? 'bg-green-500' : 
                      contract.dataQuality >= 80 ? 'bg-amber-500' : 'bg-red-500'
                    }`}
                    style={{ width: `${contract.dataQuality}%` }}
                  ></div>
                </div>
              </div>
              <div className="bg-white rounded-lg p-4">
                <div className="flex items-center gap-2 mb-2">
                  <Users className=" h-5 text-green-600" />
                  <span className="font-medium text-gray-900">Active Consumers</span>
                </div>
                <div className="text-2xl font-bold text-gray-900">{contract.consumers}</div>
                <div className="text-sm text-gray-600 mt-1">Connected services</div>
              </div>
            </div>
          </div>

          {/* <div className="space-y-6">
              <div className="bg-gradient-to-r from-green-50 to-blue-50 rounded-xl p-6">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
                    <GitBranch className=" h-5 text-blue-600" />
                    Consumer Dependencies
                  </h3>
                  <div className="flex bg-white rounded-lg p-1 border border-gray-200 shadow-sm">
                    <button
                      onClick={() => setViewMode('tree')}
                      className={`px-3 py-1.5 text-sm font-medium rounded-md transition-all duration-200 flex items-center gap-1 ${
                        viewMode === 'tree' 
                          ? 'bg-blue-100 text-blue-700 shadow-sm' 
                          : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                      }`}
                    >
                      <GitBranch className="w-4 h-4" />
                      Tree
                    </button>
                    <button
                      onClick={() => setViewMode('network')}
                      className={`px-3 py-1.5 text-sm font-medium rounded-md transition-all duration-200 flex items-center gap-1 ${
                        viewMode === 'network' 
                          ? 'bg-blue-100 text-blue-700 shadow-sm' 
                          : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                      }`}
                    >
                      Network
                    </button>
                  </div>
                </div>
                
                <div className="transition-all duration-300">
                  <ConsumerTreeView consumers={contract.consumerDependencies || []} />
                </div>
              </div>
            </div> */}


            <div className="space-y-6">
              <div className="bg-gradient-to-r from-green-50 to-blue-50 rounded-xl p-6">
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-lg font-semibold text-gray-900 flex items-center gap-2">
                    <GitBranch className=" h-5 text-blue-600" />
                    Consumer Dependencies
                  </h3>
                  <div className="flex bg-white rounded-lg p-1 border border-gray-200 shadow-sm">
                    <button
                      onClick={() => setViewMode('tree')}
                      className={`px-3 py-1.5 text-sm font-medium rounded-md transition-all duration-200 flex items-center gap-1 ${
                        viewMode === 'tree' 
                          ? 'bg-blue-100 text-blue-700 shadow-sm' 
                          : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                      }`}
                    >
                      <GitBranch className="w-4 h-4" />
                      Tree
                    </button>
                    <button
                      onClick={() => setViewMode('network')}
                      className={`px-3 py-1.5 text-sm font-medium rounded-md transition-all duration-200 flex items-center gap-1 ${
                        viewMode === 'network' 
                          ? 'bg-blue-100 text-blue-700 shadow-sm' 
                          : 'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                      }`}
                    >
                      <Network className="w-4 h-4" />
                      Network
                    </button>
                  </div>
                </div>
                
                <div className="transition-all duration-300">
                  {viewMode === 'tree' ? (
                    <ConsumerTreeView consumers={contract.consumerDependencies || []} />
                  ) : (
                    <ConsumerNetworkView 
                      consumers={contract.consumerDependencies || []} 
                      contractName={contract.name}
                    />
                  )}
                </div>
              </div>
            </div>

          {/* Main Content Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-1 gap-6">
            {/* Left Column */}
            <div className="space-y-6">
              {/* Technical Details */}
              <div className="bg-gray-50 rounded-xl p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                  <Server className=" h-5 text-gray-600" />
                  Technical Information
                </h3>
                <div className="space-y-4">
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600">Data Source</span>
                    <span className="font-medium text-gray-900">{contract.dataSource}</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600">Data Freshness</span>
                    <span className="font-medium text-gray-900">{contract.freshness}</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600">Last Updated</span>
                    <span className="font-medium text-gray-900">{contract.lastUpdated}</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-600">Contract ID</span>
                    <span className="font-mono text-sm text-gray-700">{contract.id}</span>
                  </div>
                </div>
              </div>

              {/* Performance Metrics */}
              <div className="bg-gray-50 rounded-xl p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                  <Activity className=" h-5 text-gray-600" />
                  Performance Metrics
                </h3>
                <div className="space-y-4">
                  <div>
                    <div className="flex justify-between items-center mb-2">
                      <span className="text-gray-600">Throughput</span>
                      <span className="font-medium text-gray-900">1.2M records/hour</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2">
                      <div className="bg-blue-500 h-2 rounded-full" style={{ width: '75%' }}></div>
                    </div>
                  </div>
                  <div>
                    <div className="flex justify-between items-center mb-2">
                      <span className="text-gray-600">Latency</span>
                      <span className="font-medium text-gray-900">45ms avg</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2">
                      <div className="bg-green-500 h-2 rounded-full" style={{ width: '90%' }}></div>
                    </div>
                  </div>
                  <div>
                    <div className="flex justify-between items-center mb-2">
                      <span className="text-gray-600">Error Rate</span>
                      <span className="font-medium text-gray-900">0.02%</span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-2">
                      <div className="bg-green-500 h-2 rounded-full" style={{ width: '98%' }}></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Column - Consumer Dependencies */}
          
          </div>

          {/* Recommendations */}
          <div className="bg-gradient-to-r from-amber-50 to-orange-50 rounded-xl p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
              <AlertCircle className=" h-5 text-amber-600" />
              Recommendations
            </h3>
            <ul className="space-y-2">
              {statusDetails.recommendations.map((recommendation, index) => (
                <li key={index} className="flex items-start gap-2">
                  <div  className="w-[10px] h-[10px] bg-amber-500 rounded-full mt-2 flex-shrink-0"></div>
                  <span className="text-gray-700">{recommendation}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Recent Activity */}
          <div className="bg-gray-50 rounded-xl p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
              <Calendar className=" h-5 text-gray-600" />
              Recent Activity
            </h3>
            <div className="space-y-3">
              <div className="flex items-center gap-3 p-3 bg-white rounded-lg">
                <div className="w-[10px] h-[10px] bg-green-500 rounded-full"></div>
                <span className="text-sm text-gray-700">Data quality check passed</span>
                <span className="text-xs text-gray-500 ml-auto">2 minutes ago</span>
              </div>
              <div className="flex items-center gap-3 p-3 bg-white rounded-lg">
                <div className="w-[10px] h-[10px] bg-blue-500 rounded-full"></div>
                <span className="text-sm text-gray-700">Schema validation completed</span>
                <span className="text-xs text-gray-500 ml-auto">15 minutes ago</span>
              </div>
              <div className="flex items-center gap-3 p-3 bg-white rounded-lg">
                <div className="w-[10px] h-[10px] bg-amber-500 rounded-full"></div>
                <span className="text-sm text-gray-700">Consumer connection timeout detected</span>
                <span className="text-xs text-gray-500 ml-auto">1 hour ago</span>
              </div>
            </div>
          </div>

        </div>

        {/* Footer */}
        <div className="flex justify-end gap-3 p-6 border-t border-gray-200">
          <button
            onClick={onClose}
            className="px-6 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
          >
            Close
          </button>
          {/* <button className="px-4 py-3 bg-blue-600 text-white hover:bg-blue-700 rounded-lg transition-colors flex items-center gap-2">
            <Zap className=" h-4" />
            Run Health Check
          </button> */}
        </div>
      </div>
    </div>
  );
};